import React from 'react';
import clsx from 'clsx';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverable?: boolean;
  bordered?: boolean;
  elevated?: boolean;
  padded?: boolean;
}

export const Card: React.FC<CardProps> = ({
  hoverable, bordered = true, elevated, padded = true, className, children, ...rest
}) => (
  <div
    className={clsx(
      'bg-surface rounded-2xl',
      bordered && 'border border-border',
      elevated ? 'shadow-elevated' : 'shadow-soft',
      hoverable && 'transition-all duration-200 hover:shadow-elevated hover:-translate-y-0.5',
      padded && 'p-5',
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle, action, icon, className }) => (
  <div className={clsx('flex items-start justify-between mb-4', className)}>
    <div className="flex items-start gap-3">
      {icon && (
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary">
          {icon}
        </div>
      )}
      <div>
        <h3 className="font-display text-base font-semibold text-text-primary tracking-tight">{title}</h3>
        {subtitle && <p className="text-xs text-text-muted mt-0.5">{subtitle}</p>}
      </div>
    </div>
    {action}
  </div>
);
